{
  "card": {
    "title": "Funding Status"
  },
  "status": {
    "not_funded": "Not Funded",
    "partially_funded": "Partially Funded",
    "pending_review": "Pending Review",
    "eligible": "Eligible",
    "pending": "Pending"
  },
  "progress": {
    "required": "Required Contribution",
    "funded": "Confirmed Contributions",
    "pending": "Pending Review",
    "remaining": "Remaining to Fund"
  },
  "alerts": {
    "pendingReview": {
      "title": "Contribution Under Review",
      "description": "Your contribution is being reviewed by an administrator. You'll be notified once it's confirmed."
    },
    "notFunded": {
      "title": "Contribution Required",
      "description": "You need to send your initial contribution to become eligible for profit allocations. Review the payment instructions below and submit your contribution details once sent."
    }
  },
  "eligible": {
    "title": "Fully Funded",
    "subtitle": "You are eligible for profit allocations",
    "basePrincipal": "Base Principal"
  },
  "pending": {
    "title": "Pending Contributions",
    "sentOn": "Sent on",
    "method": "Payment Method",
    "reference": "Reference"
  },
  "instructions": {
    "title": "Payment Instructions"
  },
  "form": {
    "title": "Log Your Contribution",
    "logContribution": "Log a Contribution",
    "amount": {
      "label": "Amount Sent",
      "placeholder": "Enter amount",
      "required": "Please enter the amount you sent",
      "min": "Amount must be greater than 0",
      "remaining": "Remaining needed: {{amount}}"
    },
    "sentAt": {
      "label": "Date Sent",
      "required": "Please select the date you sent the payment"
    },
    "paymentMethod": {
      "label": "Payment Method",
      "placeholder": "Select payment method",
      "required": "Please select a payment method"
    },
    "reference": {
      "label": "Reference / Transaction ID (Optional)",
      "placeholder": "e.g., Last 4 digits, confirmation number",
      "help": "Any reference number or identifier from your transfer"
    },
    "note": {
      "label": "Additional Notes (Optional)",
      "placeholder": "Any additional information about this transfer",
      "help": "This will help the administrator verify your contribution"
    },
    "submit": "Submit for Review",
    "cancel": "Cancel",
    "submitSuccess": "Contribution submitted successfully! An administrator will review it soon.",
    "submitError": "Failed to submit contribution. Please try again."
  },
  "paymentMethods": {
    "bank_transfer": "Bank Transfer",
    "zelle": "Zelle",
    "cash_app": "Cash App",
    "venmo": "Venmo",
    "other": "Other"
  },
  "errors": {
    "loadFailed": "Failed to load contribution status"
  },
  "bankDeposit": {
    "title": "Bank Deposit",
    "description": "Fund your account directly from your linked bank account",
    "methodChoice": {
      "title": "Choose Funding Method",
      "description": "Select how you would like to fund your account to become eligible for profit allocations.",
      "bankOption": "Connect Bank Account",
      "bankDescription": "Transfer funds directly from your bank account via ACH",
      "manualOption": "Manual Funding",
      "manualDescription": "Send payment off-platform and log it for admin review"
    },
    "authorize": {
      "button": "Authorize Deposit",
      "retry": "Retry Deposit",
      "confirm": "Confirm Deposit",
      "cancel": "Cancel",
      "title": "Authorize Initial Deposit",
      "description": "You are about to authorize an ACH deposit from your default bank account.",
      "amount": "Deposit Amount",
      "bankAccount": "From Bank Account",
      "processing": "Processing deposit..."
    },
    "status": {
      "pending": "Deposit Pending",
      "processing": "Deposit Processing",
      "completed": "Deposit Completed",
      "failed": "Deposit Failed",
      "succeeded": "Deposit Succeeded",
      "cancelled": "Deposit Cancelled",
      "pendingDescription": "Your deposit request has been created and is awaiting processing.",
      "processingDescription": "Your deposit is being processed. This typically takes 1-3 business days.",
      "succeededDescription": "Your deposit has been completed successfully!",
      "failedDescription": "Your deposit failed. You can try again or contact support.",
      "cancelledDescription": "Your deposit was cancelled.",
      "completedTitle": "Deposit Confirmed — You're Now Eligible!",
      "completedDescription": "Your deposit has been successfully confirmed and credited to your account. You are now eligible for profit allocations.",
      "amount": "Amount",
      "created": "Created",
      "transferId": "Transfer ID",
      "failureReason": "Failure Reason"
    },
    "refresh": {
      "button": "Refresh Status",
      "success": "Transfer status updated",
      "error": "Failed to refresh status. Please try again."
    },
    "errors": {
      "noBankAccount": "You must link a bank account first",
      "noDefaultAccount": "You must have an active default bank account",
      "alreadyEligible": "You are already eligible for earnings",
      "pendingDeposit": "You already have a pending deposit",
      "createFailed": "Failed to create deposit request. Please try again."
    },
    "success": {
      "created": "Deposit request created successfully!"
    },
    "backToManual": "Use Manual Funding Instead"
  }
}
